import { render, staticRenderFns } from "./CustomerServiceManagement.vue?vue&type=template&id=502ddf74&scoped=true"
import script from "./CustomerServiceManagement.vue?vue&type=script&lang=js"
export * from "./CustomerServiceManagement.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceManagement.vue?vue&type=style&index=0&id=502ddf74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ddf74",
  null
  
)

export default component.exports